var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { BoldSpan, Card } from "@atlassiansox/microscopekit";
import { errorList, statusLozenge } from "../../utils/Utils";
import SectionMessage from "@atlaskit/section-message";
import { TimeComponent } from "../TimeComponent";
export var SteadyStateExecutionView = function (props) {
    var probeMetric = "";
    var status = props.steadyStateExecution.status;
    var staticKeys = ["probe_metric"];
    var parameters = props.steadyStateExecution.parameters
        ? props.steadyStateExecution.parameters
        : new Map();
    Object.entries(parameters).forEach(function (entry) {
        var _a = __read(entry, 2), key = _a[0], value = _a[1];
        if (key === "probe_metric") {
            probeMetric = value;
        }
    });
    return (React.createElement(Card, null,
        React.createElement("h4", null,
            "Stop Condition :",
            statusLozenge(status)),
        React.createElement("p", null,
            "Probe Metric: ",
            probeMetric),
        React.createElement("p", null,
            React.createElement(BoldSpan, null, "Parameters")),
        React.createElement("ul", null, Object.entries(parameters).map(function (entry) {
            var _a = __read(entry, 2), key = _a[0], value = _a[1];
            if (staticKeys.indexOf(key) < 0) {
                return (React.createElement("li", null,
                    key,
                    " : ", value === null || value === void 0 ? void 0 :
                    value.toString()));
            }
            return null;
        })),
        React.createElement(TimeComponent, { createdAt: props.steadyStateExecution.createdAt, updatedAt: props.steadyStateExecution.updatedAt, status: status }),
        React.createElement("div", { hidden: errorList.indexOf(status.toLowerCase()) < 0 },
            React.createElement(SectionMessage, { appearance: "error", title: "Execution Failed" }, props.steadyStateExecution.statusMessage))));
};
